import React from 'react';

import { Grid, Tooltip } from '@mui/material';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import IconButton from '@components/IconButton';

const DrawerSettingsIconButton = ({
  areaHasSelectedSetting,
  isDrawerOpen,
  handleOnClick,
  tooltipTitle
}) => {
  return (
    <Grid>
      <Tooltip title={tooltipTitle} placement="right">
        <IconButton
          sx={[
            {
              color: 'navigationDrawer.icon.base',
              borderRadius: 0,
              '& .MuiTouchRipple-ripple .MuiTouchRipple-child': {
                borderRadius: 0
              }
            },
            isDrawerOpen ? { width: '100%' } : { px: 0.5, py: 0.5, mt: 1 },
            areaHasSelectedSetting && {
              backgroundColor: 'navigationDrawer.background.selected',
              color: 'navigationDrawer.icon.selected'
            }
          ]}
          size={isDrawerOpen ? '' : 'small'}
          onClick={handleOnClick}
          aria-label={tooltipTitle}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    </Grid>
  );
};

export default DrawerSettingsIconButton;
